import useDjangoWaffle from "@shared/hooks/djangoWaffle/useDjangoWaffle";
import { PURCHASE_SOURCE_PLATFORM_MAP } from "@shared/constants/enums";
import { RoktLauncher } from "@shared/modules/checkout/components/RoktLauncher/RoktLauncher";
import { PostPurchaseMarketingProps } from "./PostPurchaseMarketingProps";

export function PostPurchaseMarketing(
  props: PostPurchaseMarketingProps
): JSX.Element {
  const { FLAGS } = useDjangoWaffle();
  const {
    transactionId,
    email,
    firstName,
    lastName,
    mobile,
    country,
    billingZipCode,
    language,
    eventVenue,
    purchaseSourcePlatform,
    venue,
  } = props;

  // Determine which Rokt setting to use based on purchase platform
  // TODO deprecate `enable_rokt_confirmation_advertisements_widget`
  const isWidgetPlatform =
    purchaseSourcePlatform === PURCHASE_SOURCE_PLATFORM_MAP.PLATFORM_WIDGET.id;
  const shouldShowRokt = isWidgetPlatform
    ? venue?.enable_rokt_confirmation_advertisements_widget
    : venue?.enable_rokt_confirmation_advertisements;

  return (
    <>
      {/* Rokt Marketing */}
      {FLAGS.rokt_confirmation_advertisements && shouldShowRokt && (
        <RoktLauncher
          transactionId={transactionId}
          email={email}
          firstName={firstName}
          lastName={lastName}
          mobile={mobile}
          country={country}
          billingZipCode={billingZipCode}
          language={language}
          eventVenue={eventVenue}
        />
      )}
      {/* Future marketing components can be added here */}
    </>
  );
}
